// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hql8","toggle":"styles_toggle__127Qv","preview":"styles_preview__2bDH1"};